import { initialState, stateGetter, stateMutations, calculatePromoBenefits } from './cartHelper'
import { getProvider } from '@/apollo'
import queryOrderCart from './gql/queryOrderCart'

const OrderCartModule = {
  namespaced: true,
  state: {
    ...initialState,
    kwkToken: null,
    hideKwkToken: false,
    kwkPromotions: [],
    kwkPromotionIds: [],
    promoTextRows: []
  },
  getters: {
    ...stateGetter,
    kwkToken: state => state.kwkToken,
    hideKwkToken: state => state.hideKwkToken,
    kwkPromotions: state => state.kwkPromotions,
    kwkPromotionIds: state => state.kwkPromotionIds,
    promoTextRows: state => state.promoTextRows
  },
  actions: {
    async queryCart ({ commit, state, rootGetters }, { token = null }) {
      let tariffoptions = []
      if (state.selectedTariffOptionIds && state.selectedTariffOptionIds.length > 0) {
        tariffoptions = state.selectedTariffOptionIds.map(id => { return { tariffoptionId: id } })
      }
      const product = {
        tariffoptions,
        genericToken: token,
        promoCode: state.voucherCode,
        campaignCode: state.kwkToken,
        triggerDefault: true
      }
      let network = null
      if (rootGetters['checkoutv2/ordering/_mnpData/active']) {
        const provider = rootGetters['checkoutv2/ordering/_mnpData/provider']
        network = {
          networkKey: provider?.network || null,
          providerKey: provider?.key || null,
          mnp: true
        }
      }
      const variables = {
        cart: {
          brand: 'simon',
          orderContext: { market: 'PUC' },
          product,
          network
        }
      }
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: queryOrderCart,
        variables
      }).then((response) => {
        const result = response.data.orderCart
        const targetPromotions = result.targetPromotion || []
        commit('setTargetTariff', result.targetTariff)
        commit('setTargetTariffoptions', result.targetTariffoptions?.bookableTariffoptions || [])
        commit('setTargetPromotions', targetPromotions)
        commit('setKwkToken', result.campaignToken || null)
        commit('setKwkPromotions', targetPromotions.filter(promo => state.kwkPromotionIds.includes(promo.promotionId)) || [])
        commit('setVoucherCode', result.promoCode || null)
        commit('setVoucherPromotions', targetPromotions.filter(promo => promo.requiredParameters?.find(element => element === 'promoCode')) || [])
        commit('setPromoBenefits', calculatePromoBenefits({
          tariff: result.targetTariff,
          tariffoptions: result.targetTariffoptions?.bookableTariffoptions || [],
          promotions: targetPromotions
        }))
        if (token !== null) {
          return token === result.promoCode ? { tokenType: 'voucher' } : { tokenType: 'kwk' }
        }
        return true
      }).catch((error) => {
        throw error
      })
    },
    async removeVoucher ({ commit, dispatch }) {
      commit('setVoucherCode', null)
      commit('setVoucherPromotions', null)
      await dispatch('queryCart', {}).then((response) => {
        return response
      }).catch((error) => {
        throw error
      })
    },
    async removeKwkToken ({ commit, dispatch }) {
      commit('setKwkToken', null)
      commit('setKwkPromotions', [])
      await dispatch('queryCart', {}).then((response) => {
        return response
      }).catch((error) => {
        throw error
      })
    },
    setOrderCart ({ commit, rootGetters, dispatch }, { tariffId = null, tariffoptionId = null, mnp = null, provider = null }) {
      const cart = rootGetters['promotion/getCartForSelection']({ tariffId, tariffoptionId, mnp, provider })
      commit('setTargetTariff', cart.targetTariff)
      commit('setTargetTariffoptions', cart.targetTariffoption)
      commit('setTargetPromotions', cart.targetPromotions)
      commit('setPromoBenefits', calculatePromoBenefits({
        tariff: cart.targetTariff,
        tariffoptions: cart.targetTariffoption,
        promotions: cart.targetPromotions
      }))
      return true
    }
  },
  mutations: {
    ...stateMutations,
    setKwkToken (state, token) {
      state.kwkToken = token
    },
    setKwkPromotions (state, kwkPromotions) {
      state.kwkPromotions = kwkPromotions
    },
    setKwkPromoIds (state, kwkPromotionIds) {
      state.kwkPromotionIds = kwkPromotionIds
    },
    hideKwkToken (state) {
      state.hideKwkToken = true
    },
    addPromoTextRow (state, text) {
      if (!state.promoTextRows.includes(text)) {
        state.promoTextRows.push(text)
      }
    },
    resetState (state) {
      Object.assign(state, {
        ...initialState,
        kwkToken: null,
        hideKwkToken: false,
        kwkPromotions: null,
        kwkPromotionIds: [],
        promoTextRows: []
      })
    }
  }
}

export default OrderCartModule
